import { render, staticRenderFns } from "./userFooter.vue?vue&type=template&id=36fc40f9&scoped=true&"
import script from "./userFooter.vue?vue&type=script&lang=js&"
export * from "./userFooter.vue?vue&type=script&lang=js&"
import style0 from "./userFooter.vue?vue&type=style&index=0&id=36fc40f9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fc40f9",
  null
  
)

export default component.exports